import { render, staticRenderFns } from "./PostalCodeAdd.vue?vue&type=template&id=04cb00ef&scoped=true"
import script from "./PostalCodeAdd.vue?vue&type=script&lang=js"
export * from "./PostalCodeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cb00ef",
  null
  
)

export default component.exports